import { useNavigate } from "react-router-dom"
import { HomeIcon } from "../../images/Icons"
import { useAppSelector } from '../../app/hooks'
import { useDispatch } from 'react-redux'
import { selectPromptOkCancelOnHome } from "./menuSlice"
import { MessageBoxAction, setMessageBoxAction } from "../messageBoxes/messageBoxSlice"

export function HomeButton() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const promptOkCancelOnHome = useAppSelector(selectPromptOkCancelOnHome)
    return (
        <div className='iconButton' onClick={() => {
            if (promptOkCancelOnHome) {
                dispatch(setMessageBoxAction(MessageBoxAction.GoHome))
                navigate('/MessageBox')
            }
            else
                navigate('/')
        }}>
            <HomeIcon />
        </div>
    )
}